import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import SampleRequest from "../../_shark_models/SampleRequest";

import templateContent from "./sample-request-modal.html";
import templateCreateRequestButton from "./create-request-button.html";

import { communicationManager } from "../../_shark_jaws/managers/communicationManager";
import sampleRequestManager from "../../controllers/sampleRequestManager";
import setSampleRequestShippingDataModalComponent from "../setSampleRequestShippingDataModal/setSampleRequestShippingDataModalComponent";
import visitEditView from "../../views/visits/visitEditView";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";

class SampleRequestModalComponent extends Component {
	constructor () {
		super("sampleRequestModalComponent");
		this.addTemplate("", templateContent);
		this.addTemplate("createSampleRequestButton", templateCreateRequestButton);
	}

	cancelEdits () {
		const { currSampleRequest } = Shark.get();

		if (currSampleRequest && (!currSampleRequest.isDirty() || confirm("Hai delle modifiche non salvate, vuoi davvero chiudere ed annullare le modifiche?"))) {
			currSampleRequest.restore();
		}

		this.close();
	}

	close () {
		$("#sampleRequestModal").modal("hide");
	}
	
	async createNewSampleRequestBtn_clickHandler (event, data) {
		const referenceType = this.get("referenceType");
		let referenceItem;
		console.log(Object.values(data).length);

		if (Object.values(data).length > 0) {
			referenceItem = Utils.safp(Shark.$store[this.get("referenceList")], "guid", data.guid);
		}
		else {
			switch (this.get("referenceType")) {
				case "contact":
					referenceItem = Shark.$store?.editingClient;
					break;
				case "report":
					referenceItem = Shark.$store?.currVisit;
					break;
			}
		}

		if (referenceItem) {
			if (!referenceItem?.contact?.name && referenceItem.guid !== "") {
				await visitManager.getByGuid(referenceItem.guid)
				.then(getByGuidResponse => {
					console.log({getByGuidResponse});
					if (getByGuidResponse.data.length > 0) {
						referenceItem = getByGuidResponse.data[0];
						Shark.set({
							currVisit: referenceItem,
						});
					}
				});
			}

			let currSampleRequest;
			let sampleRequestReferenceContact;

			if (referenceType === "report") {
				if (referenceItem.guid === "") {
					if (confirm("Per poter richiedere una Campionatura devi salvare il Report, vuoi salvarlo ora?")) {
						visitEditView.set("afterSaveDestination", "sampleRequest");
						visitEditView.checkClientAndSaveVisit();
					}
					return;
				}
				
				sampleRequestReferenceContact = referenceItem.contact;
			}
			else {
				sampleRequestReferenceContact = referenceItem;
			}
			currSampleRequest = this.getNewSampleRequest(sampleRequestReferenceContact.guid, this.getAddressFromContact(sampleRequestReferenceContact));

			Shark.$store.systemOutdoorPedestrianList.forEach(item => {
				currSampleRequest.outdoorRequest.pedestrianInert[item.label] = "";
			});

			Shark.set({
				currSampleRequest,
				sampleRequestReferenceContact,
				__editSampleRequest: true,
			});

			Shark.render();
		}

		// if (visitActionsComponent.get("open")) {
		// 	visitActionsComponent.close();
		// }

		this.open();
	}

	editSampleRequestBtn_clickHandler (event, data) {
		const { sampleRequestList } = Shark.get();
		const currSampleRequest = Utils.safp(sampleRequestList, "guid", data.guid);

		if (currSampleRequest) {
			Shark.set({
				currSampleRequest,
				__editSampleRequest: true,
			});
			Shark.render();
			this.open();
		}
	}

	async exportPDF (sampleRequest) {
		await this.showSampleRequest(sampleRequest);
		
		// Dave: Qui devo aggiungere numero (quando ci sarà) e Nome contatto nel nome del file.
		exportPDFComponent.set("documentSaveName", "Richiesta di Campionatura");
		exportPDFComponent.convertToPDF();
		this.close();
	}

	exportPDFBtn_clickHandler (event, data) {
		const { sampleRequestList } = Shark.get();
		const currSampleRequest = Utils.safp(sampleRequestList, "guid", data.guid);

		if (currSampleRequest) {
			this.exportPDF(currSampleRequest);
		}

	}

	getAddressFromContact (contact) {
		let address = "";

		if (contact.address) {
			address += contact.name ? contact.name + "\n" : "";
			address += contact.address ? contact.address + "\n" : "";
			address += contact.zip ? contact.zip + " - " : "";
			address += contact.city ? contact.city : "";
			address += contact.province ? "(" + contact.province + ")": "";
		}

		return address;
	}

	getNewSampleRequest (destGuid, shipAddress) {
		return new SampleRequest({
			contactGuid: destGuid || "",
			shipAddress,
			status: SampleRequest.STATUS_PENDING,
			userGuid: Shark.$store.currUser.guid,
			deliveryDate: moment().add(1, "d").format(Shark.$store.dtIsoDate),
			__minDeliveryDate: moment().add(1, "d").format(Shark.$store.dtIsoDate),
		});
	}

	init () {
		this.addComponents([exportPDFComponent, waitBoxComponent]);

		const systemIndustrialList = Shark.$store.systemIndustrialList;
		const systemOutdoorDrivableList = [
			{
				label: "VERDE ALPI",
				sizes: ["1,8/3", "1/4", "3/5", "4/8", "5/8"],
			},
			{
				label: "ISTRIA",
				sizes: ["2/6", "6/9"],
			},
			{
				label: "MILLEFIORI",
				sizes: ["2/6", "6/9"],
			},
			{
				label: "SABBIA DEL TICINO ",
				sizes: ["1,8/3", "3/5"],
			},
			{
				label: "MONTORFANO",
				notes: "<sup>**</sup>",
				sizes: ["2,5/4", "4/10"],
			},
			{
				label: "GIALLO NEW",
				sizes: ["2/4"],
			},
			{
				label: "QUARZO CHIARO",
				sizes: ["3/6"],
			},
			{
				label: "QUARZO GRIGIO",
				sizes: ["3/5,6"],
			},
			{
				label: "QUARZO MIX",
				sizes: ["3/5,6"],
			},
		];

		const systemOutdoorPedestrianList = [
			{
				label: "BIANCO CARRARA",
				notes: "",
				rare: false,
			},
			{
				label: "BIANCO ZANDOBBIO",
				notes: "",
				rare: false,
			},
			{
				label: "BOTTICINO",
				notes: "",
				rare: false,
			},
			{
				label: "ROSA CORALLO",
				notes: "",
				rare: false,
			},
			{
				label: "GIALLO SIENA",
				notes: "",
				rare: false,
			},
			{
				label: "GIALLO MORI",
				notes: "",
				rare: false,
			},
			{
				label: "BRECCIA AURORA",
				notes: "<sup>*</sup>",
				rare: true,
				rareSplit35: true,
				rarePebble14: true,
			},
			{
				label: "ARABESCATO",
				notes: "<sup>*</sup>",
				rare: true,
				rarePebble14: true,
			},
			{
				label: "BRECCIA PERNICE",
				notes: "",
				rare: false,
			},
			{
				label: "ROSSO VERONA",
				notes: "",
				rare: false,
			},
			{
				label: "ROUGE ROYAL",
				notes: "<sup>*</sup>",
				rare: true,
				rarePebble14: true,
			},
			{
				label: "MARRONE",
				notes: "<sup>*</sup>",
				rare: false,
			},
			{
				label: "BARDIGLIO SKY BLUE",
				notes: "<sup>*</sup>",
				rare: true,
				rareSplit35: true,
			},
			{
				label: "OCCHIALINO",
				notes: "",
				rare: false,
			},
			{
				label: "GRIGIO CENERE",
				notes: "<sup>*</sup>",
				rare: true,
				rareSplit35: true,
			},
			{
				label: "GRIGIO CARNICO",
				notes: "<sup>*</sup>",
				rare: true,
				rarePebble14: true,
			},
			{
				label: "NERO EBANO",
				notes: "",
				rare: false,
			},
		];

		systemOutdoorDrivableList.forEach((item, index) => {
			item.index = index;
			item.sizes = item.sizes.map((sizeLabel, sizeIndex) => { return {sizeLabel, sizeIndex}; });
			item.size = "";
		});
							
		systemOutdoorPedestrianList.forEach((item, index) => {
			item.index = index;
			item.size = "";

			// if (item.label !== "ROUGE ROYAL") {
			item.sizes = [
				{
					sizeIndex: 0,
					sizeLabel: "GRANULATO-SPLIT 3/5",
					rare: item.rareSplit35,
				},
				{
					sizeIndex: 1,
					sizeLabel: "GRANULATO-SPLIT 5/8",
					rare: item.rareSplit58,
				},
				{
					sizeIndex: 2,
					sizeLabel: "CIOTTOLO-PEBBLE 1/4",
					rare: item.rarePebble14,
				},
				{
					sizeIndex: 3,
					sizeLabel: "CIOTTOLO-PEBBLE 4/8",
					rare: item.rareSplit48,
				},
			];
			// }
			// else {
			// 	item.sizes = [
			// 		{
			// 			sizeIndex: 0,
			// 			sizeLabel: "GRANULATO-SPLIT 3/5",
			// 			rare: item.rareSplit35,
			// 		},
			// 		{
			// 			sizeIndex: 1,
			// 			sizeLabel: "GRANULATO-SPLIT 5/8",
			// 			rare: item.rareSplit58,
			// 		},
			// 		{
			// 			sizeIndex: 2,
			// 			sizeLabel: "",
			// 			rare: item.rarePebble14,
			// 		},
			// 		{
			// 			sizeIndex: 3,
			// 			sizeLabel: "CIOTTOLO-PEBBLE 4/8",
			// 			rare: item.rareSplit48,
			// 		},
			// 	];
			// }
		});
							
		Shark.set({
			systemIndustrialIpmAquapermLine: systemIndustrialList.filter(item => item.line === "ipmAquapermLine"),
			systemIndustrialIpmBasicLine: systemIndustrialList.filter(item => item.line === "ipmBasicLine"),
			systemIndustrialIpmWallCoating: systemIndustrialList.filter(item => item.line === "ipmWallCoating"),
			systemOutdoorDrivableList,
			systemOutdoorPedestrianList,
		});
	}

	open () {
		let disableIndustrial = true;
		let disableOutdoor = true;
		const { currSampleRequest } = Shark.get();

		if (currSampleRequest) {
			if (Shark.$store.__editSampleRequest) {
				disableIndustrial = !currSampleRequest.requestIndustrialSample;
				disableOutdoor = !currSampleRequest.requestOutdoorSample;
				document.querySelectorAll("#requestIndustrialSampleChk").forEach(item => item.disabled = false);
				document.querySelectorAll("#requestOutdoorSampleChk").forEach(item => item.disabled = false);
			}
			else {
				document.querySelectorAll("#requestIndustrialSampleChk").forEach(item => item.disabled = true);
				document.querySelectorAll("#requestOutdoorSampleChk").forEach(item => item.disabled = true);
			}
	
			if (!currSampleRequest.requestIndustrialSample && currSampleRequest.requestOutdoorSample) {
				document.querySelector("#nav-tab-outdoor").click();
			}
		}

		document.querySelectorAll("#nav-industrial input:not(#requestIndustrialSampleChk)").forEach(item => item.disabled = disableIndustrial);
		document.querySelectorAll("#nav-industrial textarea").forEach(item => item.disabled = disableIndustrial);

		document.querySelectorAll("#nav-outdoor input:not(#requestOutdoorSampleChk)").forEach(item => item.disabled = disableOutdoor);
		document.querySelectorAll("#nav-outdoor textarea").forEach(item => item.disabled = disableOutdoor);

		$("#sampleRequestModal").modal("show");
	}

	async printSampleReques (sampleRequest) {
		await this.showSampleRequest(sampleRequest);

		window.print();
		this.close();
	}

	printSampleRequesBtn_clickHandler (event, data) {
		const currSampleRequest = Utils.safp(Shark.$store.sampleRequestList, "guid", data.guid);

		if (currSampleRequest) {
			this.printSampleReques(currSampleRequest);
		}
	}

	resetErrors () {
		document.querySelectorAll(".is-invalid").forEach(item => item.classList.remove("is-invalid"));
	}

	requestIndustrialSampleChk_changeHandler (event) {
		document.querySelectorAll("#nav-industrial input:not(#requestIndustrialSampleChk)").forEach(item => item.disabled = !event.target.checked);
		document.querySelectorAll("#nav-industrial textarea").forEach(item => item.disabled = !event.target.checked);
	}

	requestOutdoorSampleChk_changeHandler (event) {
		document.querySelectorAll("#nav-outdoor input:not(#requestOutdoorSampleChk)").forEach(item => item.disabled = !event.target.checked);
		document.querySelectorAll("#nav-outdoor textarea").forEach(item => item.disabled = !event.target.checked);
	}

	saveSampleRequest () {
		const { currSampleRequest } = Shark.get();

		if (currSampleRequest) {
			waitBoxComponent.open();

			sampleRequestManager.save(currSampleRequest)
			.then(() => {
				this.close();
				setTimeout(() => {
					waitBoxComponent.close();
					if (Shark.activePage.refreshSampleRequestList) {
						Shark.activePage.refreshSampleRequestList();
					}
				}, 200);
			});
		}
	}

	sampleRequestModalCancelBtn_clickHandler () {
		this.cancelEdits();
	}

	sampleRequestModalSaveBtn_clickHandler () {
		const { currSampleRequest } = Shark.get();

		if (currSampleRequest) {
			const errors = currSampleRequest.validate();

			if (errors.length > 0) {
				this.showErrors();
				alert("Attenzione, si sono verificati i seguenti errori:\n" + errors.join("\n"));
				return;
			}

			this.saveSampleRequest();
		}
	}

	setSampleRequestStatus (sampleRequest, status) {
		waitBoxComponent.open();

		sampleRequest.set({
			status,
		});

		sampleRequestManager.setStatus(sampleRequest)
		.then(() => {
			// const newFollowUp = new ClientFollowUp({
			// 	body: `La richiesta di campionatura <strong>${sampleRequest.__requestTypeLabel}</strong> e passata in status <q class="status" data-role="status">${sampleRequest.__statusLabel}</q>.`,
			// 	clientGuid: sampleRequest.contactGuid,
			// 	referenceGuid: sampleRequest.guid,
			// 	referenceType: "sampleRequest",
			// 	status: 3,
			// 	type: "system"
			// });

			// newFollowUp.extraData = {
			// 	sampleRequestGuid: sampleRequest.guid,
			// };

			// followUpManager.save(newFollowUp);

			if (status === SampleRequest.STATUS_READY_FOR_PICKUP) {
				communicationManager.sampleRequestReadyToPickUp(sampleRequest);
			}
			else if (status === SampleRequest.STATUS_SHIPPED) {
				Shark.set({
					currSampleRequest: sampleRequest,
				});
				
				setSampleRequestShippingDataModalComponent.open();
				communicationManager.sampleRequestShipped(sampleRequest);
			}

			waitBoxComponent.close();
			this.close();

			if (Shark.activePage.refreshSampleRequestList) {
				Shark.activePage.refreshSampleRequestList();
			}
		});
	}

	setSampleRequestStatusBtn_clickHandler (event, data) {
		const currSampleRequest = Utils.safp(Shark.$store.sampleRequestList, "guid", data.guid);

		if (currSampleRequest) {
			let shouldProcede = true;
			const newStatus = parseInt(data.status);

			if (currSampleRequest.shipToContact && newStatus === SampleRequest.STATUS_READY_FOR_PICKUP && !confirm("La Richiesta di Campionatura prevedeva la spedizione al Cliente, vuoi davvero cambiare in 'l'Agente ritira in IPM'?")) {
				shouldProcede = false;
			}
			if (!currSampleRequest.shipToContact && newStatus === SampleRequest.STATUS_READY_FOR_SHIPPING && !confirm("La Richiesta di Campionatura prevedeva il ritiro in IPM, vuoi davvero cambiare in 'Spedire al Cliente'?")) {
				shouldProcede = false;
			}

			if (shouldProcede) {
				this.setSampleRequestStatus(currSampleRequest, newStatus);
			}
		}
	}

	showErrors () {
		this.resetErrors();

		const { currSampleRequest } = Shark.get();

		for (let currProp in currSampleRequest.__errors) {
			if (currSampleRequest.__errors[currProp] === true) {
				document.querySelectorAll(`[data-sh-prop="${currProp}"]`).forEach(item => item.classList.add("is-invalid"));
			}
		}
	}

	async showSampleRequest (sampleRequest) {
		const currSampleRequestDescription = await sampleRequestManager.getDescription(sampleRequest);

		Shark.set({
			currSampleRequest: sampleRequest,
			currSampleRequestDescription: currSampleRequestDescription.data,
			__editSampleRequest: false,
		});
		Shark.render();
		this.open();
	}

	showSampleRequestDetailsBtn_clickHandler (event, data) {
		const { sampleRequestList } = Shark.get();
		const currSampleRequest = Utils.safp(sampleRequestList, "guid", data.guid);

		if (currSampleRequest) {
			this.showSampleRequest(currSampleRequest);
		}
	}
}

const sampleRequestModalComponent = new SampleRequestModalComponent();

Shark.registerComponent(sampleRequestModalComponent);

export default sampleRequestModalComponent;
